/**
 * @author: lv.chen
 * @date: 2026/3/25
 * @desc: Footer组件
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { LANGUAGE_EN, LANGUAGE_CN } from '@home/_config/config';

import './index.scss';

interface ICasualCompetitorsFooterProps extends IBaseProps {}

const emailLinker = 'sallyxue@tencent.com';
// const emailLinker = <a href="mailto:sallyxue@tencent.com">sallyxue@tencent.com</a>;

const textMap: IRecord<React.ReactElement> = {
  [LANGUAGE_EN]: <div>If you have any questions regarding to this page, please contact {emailLinker}</div>,
  [LANGUAGE_CN]: <div>如有问题，请联系 {emailLinker}</div>,
};

const CasualCompetitorsFooter: React.FC<ICasualCompetitorsFooterProps> = (props) => {
  const { style, className } = props;

  const { locale } = useIntl();

  const text = textMap[locale] || textMap[LANGUAGE_EN];

  return (
    <div style={style} className={classnames('dbh-casual-competitors-footer', className)}>
      {text}
    </div>
  );
};

export default CasualCompetitorsFooter;
